import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Handleapproveapi(state = initialState, action) {
  switch (action.type) {
    case userConstants.HANDLEAPPROVEAPI_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.HANDLEAPPROVEAPI_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.HANDLEAPPROVEAPI_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}